import { defineMessages } from 'react-intl';

import { INTL_PREFIX } from './const';

export const engravingMessages = defineMessages({
  description: {
    defaultMessage:
      'Personalize your purchase with complimentary engraving. Choose to engrave a message, name, initials or date.',
    id: `${INTL_PREFIX.ENGRAVING}.description`,
  },
  optionTitle: {
    defaultMessage: 'SELECT ENGRAVING OPTION',
    id: `${INTL_PREFIX.ENGRAVING}.optionTitle`,
  },
  optionInitials: {
    defaultMessage: 'Initials',
    id: `${INTL_PREFIX.ENGRAVING}.optionInitials`,
  },
  optionMessage: {
    defaultMessage: 'Message or Name',
    id: `${INTL_PREFIX.ENGRAVING}.optionMessage`,
  },
  optionDate: {
    defaultMessage: 'Date',
    id: `${INTL_PREFIX.ENGRAVING}.optionDate`,
  },
  enterTheCharactersTitle: {
    defaultMessage: 'ENTER THE CHARACTERS',
    id: `${INTL_PREFIX.ENGRAVING}.enterTheCharactersTitle`,
  },
  withSeparators: {
    defaultMessage: 'With separators',
    id: `${INTL_PREFIX.ENGRAVING}.withSeparators`,
  },
  styleTitle: {
    defaultMessage: 'SELECT A STYLE',
    id: `${INTL_PREFIX.ENGRAVING}.styleTitle`,
  },
  styleBlock: {
    defaultMessage: 'Block',
    id: `${INTL_PREFIX.ENGRAVING}.styleBlock`,
  },
  styleCursive: {
    defaultMessage: 'Cursive',
    id: `${INTL_PREFIX.ENGRAVING}.styleCursive`,
  },
  sizeTitle: {
    defaultMessage: 'SELECT A SIZE',
    id: `${INTL_PREFIX.ENGRAVING}.sizeTitle`,
  },
  tooltip: {
    defaultMessage:
      'Please note that the engraving and its orientation may vary slightly from the preview, as it is aligned with the caseback marker and may therefore appear at a different angle on each piece. The engraving process may also affect delivery times. As personalized items, engraved products cannot be returned. For further information, please read the {conditionsOfSaleLink} and {faqLink}.',
    id: `${INTL_PREFIX.ENGRAVING}.tooltip`,
  },
  conditionsOfSale: {
    defaultMessage: 'Conditions of Sale',
    id: `${INTL_PREFIX.ENGRAVING}.conditionsOfSale`,
  },
  faq: {
    defaultMessage: 'FAQ',
    id: `${INTL_PREFIX.ENGRAVING}.faq`,
  },
  minMaxInitialsCharacters: {
    defaultMessage: 'Minimum 2 characters, maximum 3',
    id: `${INTL_PREFIX.ENGRAVING}.minMaxInitialsCharacters`,
  },
  minMaxDateCharacters: {
    defaultMessage:
      'Min 4, max 8 digits (i.e. dd.mm, mm.yyyy, dd.mm.yyyy, etc.)',
    id: `${INTL_PREFIX.ENGRAVING}.minMaxDateCharacters`,
  },
  messageCharacterGuidance: {
    defaultMessage: 'A-Z, 0-9, "&" and spaces',
    id: `${INTL_PREFIX.ENGRAVING}.messageCharacterGuidance`,
  },
  messageCharacterGuidanceCursive: {
    defaultMessage: 'A-Z, 0-9 and spaces',
    id: `${INTL_PREFIX.ENGRAVING}.messageCharacterGuidanceCursive`,
  },
  messageSizeGuidance: {
    defaultMessage: 'Size M: 12 characters Size L: 10 characters',
    id: `${INTL_PREFIX.ENGRAVING}.messageSizeGuidance`,
  },
  lineOne: {
    defaultMessage: 'Line 1',
    id: `${INTL_PREFIX.ENGRAVING}.lineOne`,
  },
  selectedSize: {
    defaultMessage: 'Size {size}',
    id: `${INTL_PREFIX.ENGRAVING}.selectedSize`,
  },
  charactersMinLength: {
    defaultMessage: 'You need to enter at least 2 characters',
    id: `${INTL_PREFIX.ENGRAVING}.charactersMinLength`,
  },
  messageInvalidCharacters: {
    defaultMessage:
      'Only letters {lettersRange}, numbers {numbersRange}, and the symbol {ampersandSymbol} are allowed',
    id: `${INTL_PREFIX.ENGRAVING}.messageInvalidCharacters`,
  },
  messageInvalidCharactersCursive: {
    defaultMessage: 'Only letters (A-Z), numbers (0-9) and spaces are allowed',
    id: `${INTL_PREFIX.ENGRAVING}.messageInvalidCharactersCursive`,
  },
  messageCursiveAmpersandNotSupported: {
    defaultMessage:
      'The "&" character is not supported in cursive engraving. Please use block style or remove it.',
    id: `${INTL_PREFIX.ENGRAVING}.messageCursiveAmpersandNotSupported`,
  },
  messageInvalidCharactersLettersRange: {
    defaultMessage: '(A-Z)',
    id: `${INTL_PREFIX.ENGRAVING}.messageInvalidCharactersLettersRange`,
  },
  messageInvalidCharactersNumbersRange: {
    defaultMessage: '(0-9)',
    id: `${INTL_PREFIX.ENGRAVING}.messageInvalidCharactersNumbersRange`,
  },
  messageInvalidCharactersAmpersand: {
    defaultMessage: '"&"',
    id: `${INTL_PREFIX.ENGRAVING}.messageInvalidCharactersAmpersand`,
  },
  messageTooLongLarge: {
    defaultMessage:
      'Maximum {largeLimit} for size L. To add up to {mediumLimit}, please {selectFontMAction}.',
    id: `${INTL_PREFIX.ENGRAVING}.messageTooLongLarge`,
  },
  messageLargeCharacterLimit: {
    defaultMessage: '10 characters',
    id: `${INTL_PREFIX.ENGRAVING}.messageLargeCharacterLimit`,
  },
  messageMediumCharacterLimit: {
    defaultMessage: '12 characters',
    id: `${INTL_PREFIX.ENGRAVING}.messageMediumCharacterLimit`,
  },
  messageSelectFontM: {
    defaultMessage: 'select size M',
    id: `${INTL_PREFIX.ENGRAVING}.messageSelectFontM`,
  },
  messageTooLongMedium: {
    defaultMessage: 'Maximum 12 characters for size M.',
    id: `${INTL_PREFIX.ENGRAVING}.messageTooLongMedium`,
  },
  engravingUnavailable: {
    defaultMessage: 'Engraving is unavailable',
    id: `${INTL_PREFIX.ENGRAVING}.engravingUnavailable`,
  },
  engravingCardTitle: {
    defaultMessage: 'Breitling Engraving',
    id: `${INTL_PREFIX.ENGRAVING}.engravingCardTitle`,
  },
  size: {
    defaultMessage: 'Size',
    id: `${INTL_PREFIX.ENGRAVING}.size`,
  },
  style: {
    defaultMessage: 'Style',
    id: `${INTL_PREFIX.ENGRAVING}.style`,
  },
  characters: {
    defaultMessage: 'Characters',
    id: `${INTL_PREFIX.ENGRAVING}.characters`,
  },
  onlyDigitsAndDots: {
    defaultMessage: 'Only digits and dots are allowed',
    id: `${INTL_PREFIX.ENGRAVING}.onlyDigitsAndDots`,
  },
  dateMustBeDdMmYyyy: {
    defaultMessage: 'Date must be dd.mm.yyyy',
    id: `${INTL_PREFIX.ENGRAVING}.dateMustBeDdMmYyyy`,
  },
  enterAtLeast4Digits: {
    defaultMessage: 'Enter at least 4 digits',
    id: `${INTL_PREFIX.ENGRAVING}.enterAtLeast4Digits`,
  },
  tooManyDigitsInPart: {
    defaultMessage: 'Too many digits in one part of the date',
    id: `${INTL_PREFIX.ENGRAVING}.tooManyDigitsInPart`,
  },
  useDdMmOrMmYyOrMYyyy: {
    defaultMessage: 'Use dd.mm, mm.yy or m.yyyy',
    id: `${INTL_PREFIX.ENGRAVING}.useDdMmOrMmYyOrMYyyy`,
  },
  yearMustBe4Digits: {
    defaultMessage: 'Year must be 4 digits',
    id: `${INTL_PREFIX.ENGRAVING}.yearMustBe4Digits`,
  },
  invalidDay: {
    defaultMessage: 'Invalid day',
    id: `${INTL_PREFIX.ENGRAVING}.invalidDay`,
  },
  invalidMonth: {
    defaultMessage: 'Invalid month',
    id: `${INTL_PREFIX.ENGRAVING}.invalidMonth`,
  },
  invalidYear: {
    defaultMessage: 'Invalid year',
    id: `${INTL_PREFIX.ENGRAVING}.invalidYear`,
  },
  leapYearRequired: {
    defaultMessage: '29.02 requires a leap year',
    id: `${INTL_PREFIX.ENGRAVING}.leapYearRequired`,
  },
  invalidDayForMonth: {
    defaultMessage: 'Invalid day for the given month',
    id: `${INTL_PREFIX.ENGRAVING}.invalidDayForMonth`,
  },
});
